"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { TreeListContainer } from "Containers/TreeListContainer"; // не удалаять!

import { user } from "Models/UserModel";
import classNames from 'classnames';
import TableToolBar from 'Components/TableToolBar';
import D5Table from "Components/TableCore/table/D5Table";
import TreeList from "Components/TableCore/tree/TreeList";
import FormEditTableStore from "Stores/Forms/FormEditTableStore";
import { formEditTableFormShowTable } from "Actions/Forms/FormEditTableActions";
import { System } from "Constants/objects";
import assert from 'assert';
import { formFocusTable } from "Actions/Forms/FormActions";
import { isEmptyValue } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    fullHeight: {
      height: '100%',
      backgroundColor: '#fafafa'
    },
    insideFormPadding: {
      padding: '1px'
    },
    paperRoot: {
      height: 'calc(100% - 110px)'
    }
  };
};

var FormEditTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormEditTable, _React$Component);

  function FormEditTable(props) {
    var _this;

    _classCallCheck(this, FormEditTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormEditTable).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = FormEditTableStore.getInitList();
    _this.UUID = _this.props.UUID; // if (this.props.formTableMode)

    _this.onFormMouseClick = _this.onFormMouseClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(FormEditTable, [{
    key: "_onChange",
    value: function _onChange() {
      var storeData = FormEditTableStore.getList(this.UUID);
      this.setState(storeData);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      FormEditTableStore.setStoreGuid(this.UUID);
      FormEditTableStore.setStoreFormID(this.props.formID, this.UUID);
      this.onFormMouseClick();
      FormEditTableStore.addChangeListener(this._onChange);
      setTimeout(function () {
        formEditTableFormShowTable(true, _this2.UUID);
      }); //if (this.props.formTableMode) {

      $(this.el).on('click', this.onFormMouseClick); //}
      // this.setResizeFormEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // if (this.props.formTableMode) {
      $(this.el).off('click', this.onFormMouseClick); // }

      FormEditTableStore.removeChangeListener(this._onChange);
      FormEditTableStore.destructor(this.UUID);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (!this.props.formTableMode && this.UUID !== nextProps.UUID) {
        FormEditTableStore.updateStoreGuid(this.UUID, nextProps.UUID);
        this.UUID = nextProps.UUID;
      }

      if (nextProps.formID !== this.props.formID) {
        setTimeout(function () {
          formEditTableFormShowTable(false, _this3.UUID);
          formEditTableFormShowTable(true, _this3.UUID);
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var deepStrictEqual = assert.deepStrictEqual;

      try {
        deepStrictEqual(this.props, nextProps);
        deepStrictEqual(this.state, nextState);
      } catch (e) {
        return true;
      }

      return false;
    }
  }, {
    key: "setResizeFormEvent",
    value: function setResizeFormEvent() {
      var storageKey = "".concat(user.getUserID(), "-form-height-").concat(this.props.formID, "-").concat(this.props.parentFormID);
      var heightValue = localStorage.getItem(storageKey);
      $('#detail-form-' + this.props.formID).dxResizable({
        height: heightValue || 600,
        handles: 'bottom',
        onResizeEnd: function onResizeEnd(event) {
          localStorage.setItem(storageKey, event.height);
        }
      });
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      switch (this.props.formType) {
        case System.FORM_TYPE.LIST:
          return D5Table;

        case System.FORM_TYPE.TREE:
          return TreeList;

        default:
          return null;
      }
    }
  }, {
    key: "onFormMouseClick",
    value: function onFormMouseClick() {
      //запись в store фокусированого комонента
      formFocusTable(this.UUID);
    }
  }, {
    key: "showTable",
    value: function showTable() {
      var _this$state = this.state,
          showTable = _this$state.showTable,
          cMenu = _this$state.dataContextMenu;
      return showTable && !isEmptyValue(cMenu);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          formID = _this$props.formID,
          filtersData = _this$props.filtersData,
          formTableMode = _this$props.formTableMode,
          parentFormID = _this$props.parentFormID,
          popupInst = _this$props.popupInst,
          formType = _this$props.formType,
          parentUUID = _this$props.parentUUID,
          formFilters = _this$props.formFilters,
          masterObjKeyFieldName = _this$props.masterObjKeyFieldName,
          detailObjKeyFieldName = _this$props.detailObjKeyFieldName,
          viewSource = _this$props.viewSource,
          requestColumns = _this$props.requestColumns,
          tableData = _this$props.tableData,
          relationType = _this$props.relationType,
          owner = _this$props.owner,
          viewMode = _this$props.viewMode,
          isReadOnly = _this$props.isReadOnly;
      var dataContextMenu = this.state.dataContextMenu;
      var ViewComponent = this.getComponent();
      var UUID = formTableMode ? this.UUID : this.props.UUID;
      return React.createElement("div", {
        className: classNames('form-edit-table', classes.fullHeight, classes.insideFormPadding),
        ref: function ref(r) {
          return _this4.el = r;
        }
      }, React.createElement(TableToolBar, {
        formID: formID,
        formUUID: UUID,
        formTableMode: formTableMode,
        formType: formType,
        parentUUID: parentUUID,
        isReadOnly: isReadOnly,
        viewMode: viewMode
      }), this.showTable() && ViewComponent && React.createElement(ViewComponent, {
        formID: formID,
        filtersData: filtersData,
        dataContextMenu: dataContextMenu,
        formUUID: UUID,
        parentUUID: parentUUID,
        formTableMode: formTableMode,
        parentFormID: parentFormID,
        popupInst: popupInst,
        masterObjKeyFieldName: masterObjKeyFieldName,
        detailObjKeyFieldName: detailObjKeyFieldName,
        viewSource: viewSource,
        requestColumns: requestColumns,
        tableData: tableData,
        relationType: relationType,
        owner: owner,
        formFilters: formFilters,
        isReadOnly: isReadOnly
      }));
    }
  }]);

  return FormEditTable;
}(React.Component);

_defineProperty(FormEditTable, "propTypes", {
  classes: PropTypes.object.isRequired,
  formType: PropTypes.number
});

export default withStyles(styles)(FormEditTable);